export default "/assets/Icon/Mute.svg"